import { defineStore } from 'pinia';
import { useSessionStore } from '@/store/session';
import { useAppStore } from '@/store/app';

export const useStorageStore = defineStore('storage', () => {
    const sessionStore = useSessionStore();
    const appStore = useAppStore();

    const exists = computed(() => !!getItem.value);

    const getItem = computed(() => {
        return sessionStore?.order?.items?.find((item) => item.productable_type === 'storage') ?? null;
    });

    const getProduct = computed(() => {
        return getItem.value?.product ?? null;
    });

    const isConfirmed = computed(() => getItem.value?.status === 'CONFIRMED');

    const isDisabled = computed(() => !appStore.storage_enabled);

    async function remove(id) {
        const storageProductId = id ?? getProduct.value?.id;
        if (!storageProductId) return;
        await window.axios.delete(`/customers/book/orders/${sessionStore.getOrderId}/storage/${storageProductId}`);
        await sessionStore.retrieve();
    }

    return {
        exists,
        getItem,
        getProduct,
        isConfirmed,
        isDisabled,
        remove,
    };
});
